package link.erpango.quip.data.db.entities

import app.cash.sqldelight.async.coroutines.awaitAsList
import app.cash.sqldelight.async.coroutines.awaitAsOne
import app.cash.sqldelight.async.coroutines.awaitAsOneOrNull
import link.erpango.quip.db.QuipDb
import link.erpango.quip.domain.entities.DVehicleDocument
import link.erpango.quip.db.VehicleDocument

class VehicleDocumentDAO(
    private val db: QuipDb
): IVehicleDocumentTable {

    override suspend fun insert(document: DVehicleDocument): Long {
        db.vehicleDocumentQueries.insertDocument(
            id = document.localId, // Use localId if available, otherwise SQLite will autoincrement
            server_id = if (document.id != 0L) document.id else null,
            vehicle_vin = document.vehicleVin,
            name = document.name,
            file_path = document.filePath,
            file_type = document.fileType,
            created_at = document.createdAt,
            size_mb = document.sizeMb,
            updated_at = document.updatedAt
        )
        return lastInsertRowId()
    }

    override suspend fun lastInsertRowId(): Long {
        return db.vehicleDocumentQueries.last_insert_rowid().awaitAsOne()
    }

    override suspend fun selectAll(): List<DVehicleDocument> {
        return db.vehicleDocumentQueries.selectAll().awaitAsList().map { it.toDVehicleDocument() }
    }

    override suspend fun selectByVin(vin: String): List<DVehicleDocument> {
        return db.vehicleDocumentQueries.selectByVin(vin).awaitAsList().map { it.toDVehicleDocument() }
    }

    override suspend fun selectByServerId(serverId: Long): DVehicleDocument? {
        return db.vehicleDocumentQueries.selectByServerId(serverId).awaitAsOneOrNull()?.toDVehicleDocument()
    }

    override suspend fun deleteById(id: Long) {
        db.vehicleDocumentQueries.deleteById(id)
    }
    
    override suspend fun deleteAllByVin(vin: String) {
        db.vehicleDocumentQueries.deleteAllByVin(vin)
    }
}

fun VehicleDocument.toDVehicleDocument(): DVehicleDocument {
    return DVehicleDocument(
        id = server_id ?: 0,
        localId = id,
        vehicleVin = vehicle_vin,
        name = name,
        filePath = file_path,
        fileType = file_type,
        createdAt = created_at,
        updatedAt = updated_at,
        sizeMb = size_mb
    )
}
